import React from 'react'
import { Route } from 'react-router-dom'
import IncluirCaixa from './incluir-caixa/IncluirCaixa'
import IncluirOutrasReceitas from './incluir-outras-receitas/IncluirOutrasReceitas'
import ConsultarAlterarCaixa from './consultar-alterar-caixa/ConsultarAlterarCaixa'
import SwitchRouter from 'components/SwitchRouter'

export default function Routes() {
    return (
        <SwitchRouter>
            <Route exact path="/restaurante/fechamento-de-caixa/incluir-caixa" component={IncluirCaixa} />
            <Route path="/restaurante/fechamento-de-caixa/incluir-outras-receitas" component={IncluirOutrasReceitas} />
            <Route path="/restaurante/fechamento-de-caixa/consultar-alterar-caixa" component={ConsultarAlterarCaixa} />
        </SwitchRouter>
    )
}